import { createRootRoute, Outlet } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useBranding } from '@utils/api'
import Loading from '@components/Loading'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const { branding, isLoading } = useBranding()
  const [showSpinner, setShowSpinner] = useState(false)

  // Only show spinner after a delay to prevent flash on quick loads
  useEffect(() => {
    if (!isLoading) {
      setShowSpinner(false)
      return
    }

    const timer = setTimeout(() => setShowSpinner(true), 200)
    return () => clearTimeout(timer)
  }, [isLoading])

  useEffect(() => {
    if (!branding) return

    const root = document.documentElement
    root.style.setProperty('--primary', branding?.buttonColor)
    root.style.setProperty('--primary-foreground', branding?.fontColor)
    root.style.setProperty('--secondary', branding?.accentColor)
    root.style.setProperty('--ring', branding?.accentColor)
    root.style.setProperty('--page-background', branding?.backgroundColor || '#1a1a1a')

    // Find existing theme-color meta tag or create one
    let metaThemeColor: HTMLMetaElement | null =
      document.querySelector('meta[name="theme-color"]')

    if (!metaThemeColor) {
      metaThemeColor = document.createElement('meta')
      metaThemeColor.name = 'theme-color'
      document.head.appendChild(metaThemeColor)
    }

    // Update the content
    metaThemeColor.content = branding?.backgroundColor || 'defaultColor'
  }, [branding])

  if (isLoading) {
    return (
      <div className="!bg-page-background min-h-[100svh]">
        {showSpinner && <Loading />}
      </div>
    )
  }

  return (
    <div className="!bg-page-background min-h-[100svh]">
      <Outlet />
    </div>
  )
}
